import React, {PropTypes} from 'react';
import ReactDOM from 'react-dom';
import {Field} from 'redux-form';
import {I18n} from 'react-redux-i18n';

import FormInput from '../../common/components/FormInput';

class BarCodeField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showField: false,
    };
  }

  handleHideBarcode = () => {
    this.setState({showField: false});
  }

  handleShowBarcode = () => {
    this.setState({showField: true}, () => {ReactDOM.findDOMNode(this.refs.barcode).focus();});
  }

  render() {
    const {className} = this.props;
    return (
      <div className={className}>
        {this.state.showField === false && <div className="barcode float-right" onClick={this.handleShowBarcode}/>}
        {this.state.showField && <Field name="barcode"
                                        component={FormInput} 
                                        type="text" 
                                        className="form-control float-right txt-barcode"
                                        placeholder={I18n.t('ENTER_BARCODE')}
                                        onBlur={this.handleHideBarcode}
                                        ref="barcode"
        />}
      </div>
    );
  }
}

BarCodeField.propTypes = {
  className: PropTypes.string
};

export default BarCodeField;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/BarCodeField.js
 **/